function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 25,
  fill: "#fff"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.657 48.77c2.6-3.66 3.51-7.87 4.59-12.2 1.16 1.37 2.48 2.21 4.08 2.51 3.46.64 6.49-.36 9.2-2.51 5.54-4.41 7.92-15.28 2.3-21.87-2.93-3.44-6.71-5.18-11.18-5.42-4.74-.26-9.13.78-12.8 3.99-4.92 4.31-6.28 11.94-3.12 17.45.77 1.35 1.75 2.5 3.14 3.27.63.35 1.05.26 1.19-.51.05-.29.11-.58.21-.85.48-1.26.27-2.31-.41-3.54-3.39-6.18.67-14.05 7.73-15.22 1.96-.32 3.89-.28 5.8.3 4 1.21 6.53 4.34 6.89 8.77.24 2.94-.27 5.79-1.76 8.38-1.28 2.23-3.08 3.78-5.81 3.88-2.77.1-4.49-1.94-3.83-4.63.53-2.18 1.22-4.32 1.79-6.48.15-.59.18-1.22.18-1.84 0-1.32-.45-2.47-1.71-3.05-1.28-.59-2.56-.4-3.69.45-1.48 1.11-2.17 2.71-2.25 4.48-.06 1.25.25 2.51.36 3.76.05.63.17 1.29.03 1.88-.83 3.68-1.83 7.32-2.53 11.02-.37 1.92-.26 3.94-.34 5.92-.02.45.06.9.09 1.38-8.85-2.9-18.34-14.26-15.19-28.52 3.12-14.12 17.6-22.62 31.42-18.55S53.417 20 48.477 33.51c-5.05 13.85-19.81 19.01-30.82 15.26z",
  fill: "#EA1515"
});

var SvgSourcePinterest = function SvgSourcePinterest(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSourcePinterest, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/source_pinterest.8ba72758.svg";
export { ForwardRef as ReactComponent };